import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function VerifyCode({ pending, onBack }) {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const verify = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/signup/verify", { signup_id: pending.signup_id, code });
      localStorage.setItem("mus_token", data.token);
      setUser(data.user);
      toast.success("Your account is open. Welcome!");
      nav("/");
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  const resend = async () => {
    try { await api.post("/auth/signup/resend", { signup_id: pending.signup_id }); toast.success("New code sent"); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form onSubmit={verify} className="grid gap-5" data-testid="verify-form">
      <div className="h-12 w-12 rounded-full bg-blue-50 text-[var(--blue)] grid place-items-center"><MailCheck /></div>
      <div>
        <h1 className="text-3xl font-extrabold text-[var(--navy)]">Verify your email</h1>
        <p className="text-slate-500 mt-1">Enter the 6-digit code we sent to <span className="font-semibold text-[var(--navy)]" data-testid="verify-email">{pending.email}</span>.</p>
      </div>
      <Input value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))} inputMode="numeric" placeholder="000000" className="h-14 text-2xl tracking-[0.5em] text-center font-display" required data-testid="verify-code-input" />
      {error && <div className="text-sm text-[var(--red)] bg-red-50 border border-red-100 rounded-md px-3 py-2" data-testid="verify-error">{error}</div>}
      <Button disabled={busy || code.length !== 6} className="h-11 rounded-full bg-[var(--blue)] hover:bg-[var(--navy)]" data-testid="verify-submit-button">{busy ? "Verifying..." : "Verify & open account"}</Button>
      <div className="flex justify-between text-sm">
        <button type="button" onClick={onBack} className="text-slate-500 hover:text-[var(--navy)]" data-testid="verify-back-button">Change details</button>
        <button type="button" onClick={resend} className="font-semibold text-[var(--blue)]" data-testid="verify-resend-button">Resend code</button>
      </div>
    </form>
  );
}
